export { default } from './dist/vue-qrcode-reader.common'
export * from './dist/vue-qrcode-reader.common'
import './dist/vue-qrcode-reader.css'
